
export class NotFoundError extends Error {
    constructor(message: string) {
        super('HTTP 404 Error:' + message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
